import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { clearImpersonation } from '@/lib/impersonation'
import { clearAuthTokens, unregisterNativePush } from '@/lib/native'
import { QUERY_KEYS } from '@/lib/queryKeys'
import { setIsAuthenticated } from '@/store/appSlice'

export function useLogout() {
  const queryClient = useQueryClient()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  return useCallback(async () => {
    clearImpersonation()
    await unregisterNativePush()
    await clearAuthTokens()
    dispatch(setIsAuthenticated(false))
    queryClient.setQueryData([QUERY_KEYS.LOGGED_USER], null)
    queryClient.clear()
    navigate('/')
  }, [dispatch, navigate, queryClient])
}
